import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-payment-list',
  templateUrl: './report-payment-list.component.html',
  styleUrls: ['./report-payment-list.component.scss']
})
export class ReportPaymentListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
